import { noop } from "angular";
import { IModalService } from "angular-ui-bootstrap";
import { getModalTemplate } from "@gtmhub/shared/components/modal/template";
import { IKpiFormData } from "../models/models";

export class KpiFormService {
  static $inject = ["$uibModal"];

  constructor(private $uibModal: IModalService) {}

  open(formData: IKpiFormData): void {
    this.$uibModal
      .open({
        template: getModalTemplate("kpi-form"),
        windowClass: "medium-large kpi-modal",
        backdropClass: "dark-backdrop",
        backdrop: false,
        resolve: {
          formData: () => formData,
        },
        controller: "KpiFormCtrl",
        lazyLoadState: "gtmhub.kpis",
      })
      .result.catch(noop);
  }
}
